/** Shared ticket-list view state; authorization and query scope stay on the server. */
export class TicketList {
    public tickets: any[] = [];
    public loading = false;
    public error = '';
    public searchTerm = '';
    public pagination = { page: 1, end: 1, start: 1 };
    public total = 0;
    public mode = '';
    public managementDirection: string | null = null;
    private requestNumber = 0;
    private destroyed = false;

    constructor(
        private fetchRows: (params: any) => Promise<any>,
        private render: () => Promise<any>,
        public direction: 'sent' | 'received' | 'all'
    ) { }

    public setStatusFromUrl(url: string) {
        const status = new URLSearchParams(url.split('?')[1] || '').get('status') || '';
        this.mode = ['open', 'pending', 'received', 'processing', 'completed'].includes(status) ? status : '';
    }

    public dispose() { this.destroyed = true; this.requestNumber++; }

    public async load() {
        if (this.destroyed) return;
        const request = ++this.requestNumber;
        const params = { mode: this.mode, text: this.searchTerm, page: this.pagination.page };
        this.loading = true;
        this.error = '';
        this.tickets = [];
        this.total = 0;
        await this.render();
        if (request !== this.requestNumber) return;
        try {
            const response = await this.fetchRows(params);
            if (request !== this.requestNumber) return;
            if (response?.code !== 200) {
                throw new Error(typeof response?.data === 'string' ? response.data
                    : response?.data?.message || '티켓 목록을 불러오지 못했습니다.');
            }
            const data = response.data || {};
            this.tickets = Array.isArray(data.rows) ? data.rows : [];
            this.total = Number(data.total) || 0;
            this.pagination.page = Math.max(1, Number(data.page) || params.page);
            this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
            this.pagination.end = Math.max(1, Number(data.lastpage) || 1);
            if (['sent', 'received', 'all'].includes(data.direction)) this.direction = data.direction;
            this.managementDirection = ['received', 'all'].includes(data.management_direction)
                ? data.management_direction : null;
        } catch (error) {
            if (request !== this.requestNumber) return;
            this.error = error?.message || '티켓 목록을 불러오지 못했습니다.';
            this.tickets = [];
            this.total = 0;
            this.pagination = { page: 1, end: 1, start: 1 };
            this.managementDirection = null;
        } finally {
            if (request === this.requestNumber) {
                this.loading = false;
                await this.render();
            }
        }
    }

    public async pageLoad(page: number) {
        this.pagination.page = page;
        await this.load();
    }
}
